/**
 * Customer profile routes.
 *
 * The optional `:tab` param is validated — invalid values redirect to the default.
 * Feature flag gating happens in the view component (CustomerProfile.vue).
 */
import type { RouteRecordRaw } from 'vue-router';
import { CustomerProfileTabKey } from '@/components/customerProfile/constants.ts';

const VALID_TABS = Object.values(CustomerProfileTabKey);

const customers: RouteRecordRaw[] = [
    {
        path: String.raw`/customers/:id(\d+)/:tab?`,
        name: 'customers.profile',
        component: () => import('../views/Customers/CustomerProfile.vue'),
        meta: {
            blockAccount: true,
            header: {
                account: true,
                notification: true,
                search: true,
                settings: true,
            },
            layout: {
                contentHeader: false,
                contentPadding: false,
            },
        },
        beforeEnter: (to) => {
            const tab = to.params.tab as string | undefined;
            if (tab && !VALID_TABS.includes(tab as CustomerProfileTabKey)) {
                return { name: 'customers.profile', params: { id: to.params.id } };
            }
            return true;
        },
    },
];

export default customers;
